var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "done",
    xmlns: "http://www.w3.org/2000/svg",
    width: 37.135,
    height: 37.135,
    viewBox: "0 0 37.135 37.135",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_27151",
    "data-name": "Path 27151",
    d: "M0,0H37.135V37.135H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27152",
    "data-name": "Path 27152",
    d: "M11.842,21.778,6.426,16.363A1.532,1.532,0,0,0,4.26,18.529l6.483,6.483a1.541,1.541,0,0,0,2.182,0l16.4-16.386A1.532,1.532,0,0,0,27.16,6.46Z",
    transform: "translate(2.084 3.288)",
    fill: "#2f4858"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckDark);
export default __webpack_public_path__ + "static/media/check_dark.3aad8c4645caf19d7f4237d9f2cbf7d6.svg";
export { ForwardRef as ReactComponent };